import { render, staticRenderFns } from "./ProductBenefitsComponent.vue?vue&type=template&id=3ea48454&scoped=true&"
import script from "./ProductBenefitsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductBenefitsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductBenefitsComponent.vue?vue&type=style&index=0&id=3ea48454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea48454",
  null
  
)

export default component.exports